(function(){
  'use strict';
  var KEY='tronyfi_wishlist';
  function load(){try{var d=localStorage.getItem(KEY);return d?JSON.parse(d):[]}catch(e){return []}}
  function save(items){try{localStorage.setItem(KEY,JSON.stringify(items))}catch(e){}}
  function has(id){return load().some(function(x){return String(x.id)===String(id)})}
  function add(p){var items=load();if(!items.some(function(x){return String(x.id)===String(p.id)})){items.unshift(p);save(items)}refresh()}
  function remove(id){save(load().filter(function(x){return String(x.id)!==String(id)}));refresh()}
  function toggle(p){if(has(p.id)){remove(p.id);return false}else{add(p);return true}}

  function refresh(){updateBadges();updateButtons();if(isOpen())renderItems()}

  function updateBadges(){
    var count=load().length;
    document.querySelectorAll('.tn-wl-count').forEach(function(el){
      el.textContent=count;
      el.style.display=count>0?'flex':'none';
    });
  }

  function updateButtons(){
    document.querySelectorAll('[data-wl-id]').forEach(function(btn){
      btn.classList.toggle('tn-wl-active',has(btn.getAttribute('data-wl-id')));
    });
  }

  function isOpen(){var d=document.getElementById('tn-wl-drawer');return d&&d.classList.contains('tn-open')}

  function openDrawer(){
    var d=document.getElementById('tn-wl-drawer');
    var b=document.getElementById('tn-wl-backdrop');
    if(!d)return;
    renderItems();
    d.classList.add('tn-open');
    if(b)b.classList.add('tn-open');
    d.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  }

  function closeDrawer(){
    var d=document.getElementById('tn-wl-drawer');
    var b=document.getElementById('tn-wl-backdrop');
    if(d){d.classList.remove('tn-open');d.setAttribute('aria-hidden','true');}
    if(b)b.classList.remove('tn-open');
    document.body.style.overflow='';
  }

  function renderItems(){
    var wrap=document.getElementById('tn-wl-items');
    var empty=document.getElementById('tn-wl-empty');
    if(!wrap)return;
    var items=load();
    if(items.length===0){
      wrap.innerHTML='';
      if(empty)empty.style.display='flex';
      return;
    }
    if(empty)empty.style.display='none';
    wrap.innerHTML=items.map(function(p){
      return '<div class="tn-wl-item">'
        +(p.image?'<a href="'+p.url+'" class="tn-wl-img"><img src="'+p.image+'" alt="" loading="lazy"></a>':'<div class="tn-wl-img tn-wl-img-ph"></div>')
        +'<div class="tn-wl-info">'
        +(p.vendor?'<div class="tn-wl-vendor">'+p.vendor+'</div>':'')
        +'<a href="'+p.url+'" class="tn-wl-title">'+p.title+'</a>'
        +(p.price?'<div class="tn-wl-price">'+p.price+'</div>':'')
        +'</div>'
        +'<button class="tn-wl-rm" data-rm="'+p.id+'" aria-label="Remove">&#10005;</button>'
        +'</div>';
    }).join('');
    wrap.querySelectorAll('.tn-wl-rm').forEach(function(btn){
      btn.addEventListener('click',function(){remove(btn.getAttribute('data-rm'));});
    });
  }

  function init(){
    document.addEventListener('click',function(e){
      var hBtn=e.target.closest('[data-wl-id]');
      if(hBtn&&!e.target.closest('#tn-wl-drawer')){
        e.preventDefault();e.stopPropagation();
        toggle({id:hBtn.getAttribute('data-wl-id'),title:hBtn.getAttribute('data-wl-title'),url:hBtn.getAttribute('data-wl-url'),image:hBtn.getAttribute('data-wl-image'),price:hBtn.getAttribute('data-wl-price'),vendor:hBtn.getAttribute('data-wl-vendor')});
        hBtn.classList.remove('tn-wl-pop');void hBtn.offsetWidth;hBtn.classList.add('tn-wl-pop');
        setTimeout(function(){hBtn.classList.remove('tn-wl-pop');},320);
        return;
      }
      if(e.target.closest('.tn-wl-open')){e.preventDefault();openDrawer();return;}
      if(e.target.closest('.tn-wl-close')){closeDrawer();return;}
      if(e.target.id==='tn-wl-backdrop'){closeDrawer();return;}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});
    refresh();
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
